import {KIconArchive} from '@/components/icons';
import {KIconCheckmark, KIconChevronRight, KIconEnvelopeDot, KIconEnvelopeFA} from '@/components/icons/fa';
import {KRow} from '@/components/layout/KRow';
import {KStack} from '@/components/layout/KStack';
import {KMenuItem} from '@/components/menu/KMenuItem';
import {KIGetMessagesParams} from '@/hooks/useGetNotifications';
import colors from '@/styles/colors';
import {Typography} from '@mui/material';
import clsx from 'clsx';
import {useState} from 'react';

export type NotificationFiltersProps = {
  selected: KIGetMessagesParams;
  onChangeFilter: (params: KIGetMessagesParams) => void;
};

/**
 * Notification filters for read, unread and archived.
 */
export const NotificationFilters = ({selected, onChangeFilter}: NotificationFiltersProps) => {
  const [collapseInbox, setCollapseInbox] = useState(false);

  return (
    <KStack className="notifications-filters" gap={2}>
      <Typography
        style={{
          paddingLeft: 20,
          fontSize: 11,
          fontWeight: 600,
          letterSpacing: '1.7px',
          color: colors.cobaltDisabled,
        }}
      >
        NOTIFICATIONS
      </Typography>

      <KMenuItem
        selected={selected.isInbox === true}
        onClick={() => onChangeFilter({isInbox: true})}
        icon={
          <KRow gap={'14px'}>
            <div
              data-testid={`inbox-${collapseInbox ? 'expand' : 'collapse'}`}
              onClick={(event) => {
                setCollapseInbox(!collapseInbox);
                // if filtering by read or unread then set filtering to inbox
                if (selected.isRead === undefined) {
                  event.stopPropagation();
                }
              }}
            >
              <KIconChevronRight className={collapseInbox ? 'expand' : 'collapse'} color={colors.dark} />
            </div>
            <div style={{marginRight: 10}}>
              <KIconEnvelopeFA color={colors.dark} />
            </div>
          </KRow>
        }
        className={'collapseAble'}
        data-testid={'filtering-inbox'}
      >
        Inbox
      </KMenuItem>

      <KMenuItem
        selected={selected.isRead === false}
        onClick={() => onChangeFilter({isRead: false})}
        icon={<KIconEnvelopeDot color={colors.dark} style={{paddingLeft: '10px'}} />}
        sx={{pl: '35px'}}
        className={clsx({collapse: collapseInbox})}
        data-testid={'filtering-unread'}
      >
        Unread
      </KMenuItem>

      <KMenuItem
        selected={selected.isRead === true}
        onClick={() => onChangeFilter({isRead: true})}
        icon={<KIconCheckmark color={colors.dark} style={{paddingLeft: '10px'}} />}
        sx={{pl: '35px'}}
        className={clsx({collapse: collapseInbox})}
        data-testid={'filtering-read'}
      >
        Read
      </KMenuItem>

      <KMenuItem
        selected={selected.archived === true}
        onClick={() => onChangeFilter({archived: true})}
        icon={<KIconArchive />}
        sx={{pl: '23px'}}
        className={'rawIcon'}
        data-testid={'filtering-archive'}
      >
        Archive
      </KMenuItem>
    </KStack>
  );
};
